import { render, staticRenderFns } from "./studentUpdate.vue?vue&type=template&id=96ff0b1a&scoped=true"
import script from "./studentUpdate.vue?vue&type=script&lang=js"
export * from "./studentUpdate.vue?vue&type=script&lang=js"
import style0 from "./studentUpdate.vue?vue&type=style&index=0&id=96ff0b1a&prod&lang=css"
import style1 from "./studentUpdate.vue?vue&type=style&index=1&id=96ff0b1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ff0b1a",
  null
  
)

export default component.exports